var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Text } from "native-base";
import { forHumans } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import Card from "../atoms/Card/Card";
const ProtocolCard = (_a) => {
    var { protocols } = _a, rest = __rest(_a, ["protocols"]);
    const { t } = useTranslation();
    if (!protocols.length) {
        return null;
    }
    return (_jsx(Card, Object.assign({}, rest, { children: protocols.map(({ metricType, instructions }) => (_jsxs(_Fragment, { children: [_jsx(Heading, Object.assign({ size: "sm", fontWeight: "medium", mb: 1 }, { children: t(`measures:${forHumans(metricType)}`) })), _jsx(Text, Object.assign({ fontSize: "sm", color: "gray.600" }, { children: t(`backend:${instructions}`) }))] }))) })));
};
export default ProtocolCard;
